module.exports = __webpack_public_path__ + "img/um-ideal-para-compartilhar-bicicletas.ed0d8a2f.svg";